import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class PartyTemplateService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return {
                success: true,
                data: response.data || [],
                pagination: response.pagination || {},
                message: response.message || 'Party şablonları getirildi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch party template list');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch party template');
        }
    }

    async resolve(params) {
        try {
            const response = await this.api.resolve(params);
            return { success: true, data: response.data, source: response.source, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to resolve party template');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return { success: true, data: response.data, message: response.message || 'Şablon oluşturuldu' };
        } catch (error) {
            throw this._handleError(error, 'Failed to create party template');
        }
    }

    async update(id, data) {
        try {
            const response = await this.api.update(id, data);
            return { success: true, data: response.data, message: response.message || 'Şablon güncellendi' };
        } catch (error) {
            throw this._handleError(error, 'Failed to update party template');
        }
    }

    async cloneToTenant(id) {
        try {
            const response = await this.api.cloneToTenant(id);
            return {
                success: true,
                data: response.data,
                message: response.message || 'Global party şablonu tenant kapsamına klonlandı',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to clone party template');
        }
    }

    async publishNewVersion(id, data) {
        try {
            const response = await this.api.publishNewVersion(id, data);
            return { success: true, data: response.data, message: response.message || 'Yeni versiyon yayımlandı' };
        } catch (error) {
            throw this._handleError(error, 'Failed to publish new version');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return { success: true, data: response.data, message: response.message || 'Şablon silindi' };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete party template');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
